import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { MenuItemAdvanced } from '@boma/client-shared';
import {
  IProfileEntity,
  IUiStyle,
} from '@boma/supplier-portal/shared/entities';
import {
  CLEAR_STATE,
  UserState,
  getEntityDetails,
  getUiStyle,
  getUser,
  getUserBusinessAccounts,
  getUserLoaded,
  loadUser,
  setSelectedSupplier,
} from '@boma/supplier-portal/shared/state';
import { ProfileService } from '@boma/website/shared';
import { IProfile, IProfileLocation } from '@boma/website/shared/entities';
import { Store } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import jwt_decode from 'jwt-decode';
import { PrimeNGConfig } from 'primeng/api';
import { Observable, Subject, Subscription } from 'rxjs';
import { environment } from '../environments/environment';

@Component({
  selector: 'boma-supplier-portal-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'supplier-portal';
  menuMode = 'static';
  colorScheme = 'light';
  menuTheme = 'layout-sidebar-darkgray';
  overlayMenuActive: boolean;
  staticMenuDesktopInactive: boolean;
  staticMenuMobileActive: boolean;
  menuClick: boolean;
  search = false;
  searchClick = false;
  userMenuClick: boolean;
  topbarUserMenuActive: boolean;
  notificationMenuClick: boolean;
  topBarNotificationMenuActive: boolean;
  switchDirectoryMenuActive = false;
  rightMenuClick: boolean;
  rightMenuActive: boolean;
  configActive: boolean;
  configClick: boolean;
  resetMenu: boolean;
  userId = '';
  gettingAccounts = false;
  checkedUsername = false;

  showHorizontalMenu: boolean;

  menuHoverActive = false;

  inputStyle = 'outlined';

  selectedEntity: IProfileEntity;

  ripple = true;

  style$: Observable<IUiStyle>;
  user$: Observable<UserState>;
  userBusinessAccounts$: Observable<any>;

  loaded$: Observable<boolean>;

  topBarCustomMenuActions: any = [
    // {
    //   callback: 'onDirectorySwitch',
    //   iconClass: 'pi pi-inbox',
    //   displayValue: 'Switch Directory',
    // },
  ];
  menuItems: MenuItemAdvanced[];
  horizontalMenuItems: MenuItemAdvanced[];

  profile: IProfile;
  activeEntityId: string;
  activeLocationId: string;
  locations: IProfileLocation[] = [];

  authStatus = '';

  @Output() toasterMessage = new EventEmitter();
  authSvcEventSubscription$: Subscription | undefined;
  username: string | null = null;
  isStaging = false;
  showThinBar = true;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private primengConfig: PrimeNGConfig,
    private store: Store,
    private router: Router,
    private profileService: ProfileService,
    private authService: OAuthService
  ) {
    authService.configure({
      issuer: environment.authentication.issuer,
      redirectUri: `${window.location.origin}/login`,
      clientId: environment.authentication.clientId,
      responseType: 'code',
      scope: environment.authentication.scopes,
      showDebugInformation: !environment.production,
    });
    authService.loadDiscoveryDocumentAndTryLogin().then(
      (res) => {
        console.log(res);
        if (!authService.hasValidAccessToken()) {
          this.authStatus = 'Redirecting...';
          authService.initLoginFlow();
        } else {
          this.authStatus = 'Loading User...';
          this.store.dispatch(loadUser());
          this.setUsername();
          if (this.router.url.startsWith('/login')) {
            const path = localStorage.getItem('redirectURL')
              ? localStorage.getItem('redirectURL')
              : '/';
            localStorage.removeItem('redirectURL');
            this.router.navigate([path]);
          }
        }
      },
      (err) => console.log(err)
    );
    authService.setupAutomaticSilentRefresh();

    this.isStaging =
      environment.apiRoute.indexOf('staging') > -1 ||
      environment.apiRoute.indexOf('localhost') > -1;
  }

  ngOnInit(): void {
    // this.authSvcEventSubscription$ = this.authService.events.subscribe((ev) => {
    //   if (ev.type === 'token_received') {
    //     this.setUsername();
    //     this.store.dispatch(loadUser());
    //   } else if (ev.type === 'logout') {
    //     this.setUsername();
    //   }
    // });

    this.setUpMenus();

    this.primengConfig.ripple = true;
    this.loaded$ = this.store.select(getUserLoaded);
    this.style$ = this.store.select(getUiStyle);

    this.user$ = this.store.select(getUser);

    this.userBusinessAccounts$ = this.store.select(getUserBusinessAccounts);

    const ctx = this;
    this.style$.subscribe({
      next(res) {
        if (res != null) {
          (ctx.menuMode = res.menuMode !== '' ? res.menuMode : ctx.menuMode),
            (ctx.colorScheme =
              res.colorScheme !== '' ? res.colorScheme : ctx.colorScheme);
          ctx.menuTheme =
            res.menuTheme !== ''
              ? 'layout-sidebar-' + res.menuTheme
              : ctx.menuTheme;

          ctx.ripple = res.ripple != null ? res.ripple : ctx.ripple;

          ctx.changeStyleSheetsColor(
            'theme-css',
            'theme-' + ctx.colorScheme + '.css',
            res.componentTheme !== '' ? res.componentTheme : 'blue'
          );

          if (res.colorScheme !== '') {
            ctx.changeStyleSheetsColor(
              'layout-css',
              'layout-' + res.colorScheme + '.css',
              null
            );

            const mobileLogoLink: HTMLImageElement = document.getElementById(
              'logo-mobile'
            ) as HTMLImageElement; // sometimes this is not loaded yet... move into app component to resolve
            const footerLogoLink: HTMLImageElement = document.getElementById(
              'footer-logo'
            ) as HTMLImageElement;
            const appLogoLink: HTMLImageElement = document.getElementById(
              'app-logo'
            ) as HTMLImageElement;

            //TODO Removing this as it resets the suppliers logo.
            // if (mobileLogoLink) {
            //   if (res.colorScheme === 'light') {
            //     mobileLogoLink.src =
            //       'assets/layout/images/logo-dark-text-2021.svg';
            //     footerLogoLink.src = 'assets/layout/images/logo-dark.svg';
            //     if (res.menuTheme === 'white') {
            //       appLogoLink.src =
            //         'assets/layout/images/logo-dark-text-2021.svg';
            //     } else {
            //       appLogoLink.src =
            //         'assets/layout/images/logo-light-text-2021.svg';
            //     }
            //   } else {
            //     mobileLogoLink.src =
            //       'assets/layout/images/logo-light-text-2021.svg';
            //     footerLogoLink.src = 'assets/layout/images/logo-light.svg';
            //     appLogoLink.src =
            //       'assets/layout/images/logo-light-text-2021.svg';
            //   }
            // }
          }
        }
      },
    });
  }

  async loadProfile() {
    await this.profileService.loadUserProfile();
  }

  changeStyleSheetsColor(id, value, sub) {
    const element = document.getElementById(id);
    const urlTokens = element.getAttribute('href').split('/');

    urlTokens[urlTokens.length - 1] = value;
    if (sub != null) {
      // we have a sub.. add it
      urlTokens[urlTokens.length - 2] = sub;
    }
    const newURL = urlTokens.join('/');
    this.replaceLink(element, newURL);
  }

  replaceLink(linkElement, href) {
    if (this.isIE()) {
      linkElement.setAttribute('href', href);
    } else {
      const id = linkElement.getAttribute('id');
      const cloneLinkElement = linkElement.cloneNode(true);

      cloneLinkElement.setAttribute('href', href);
      cloneLinkElement.setAttribute('id', id + '-clone');

      linkElement.parentNode.insertBefore(
        cloneLinkElement,
        linkElement.nextSibling
      );

      cloneLinkElement.addEventListener('load', () => {
        linkElement.remove();
        cloneLinkElement.setAttribute('id', id);
      });
    }
  }

  isIE() {
    return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
  }

  onLayoutClick() {
    if (!this.searchClick) {
      this.search = false;
    }

    if (!this.userMenuClick) {
      this.topbarUserMenuActive = false;
    }

    if (!this.notificationMenuClick) {
      this.topBarNotificationMenuActive = false;
    }

    if (!this.rightMenuClick) {
      this.rightMenuActive = false;
    }

    if (!this.menuClick) {
      if (this.isSlim()) {
        // this.menuService.reset();
      }

      if (this.overlayMenuActive || this.staticMenuMobileActive) {
        this.hideOverlayMenu();
      }

      this.menuHoverActive = false;
      this.unblockBodyScroll();
    }

    if (this.configActive && !this.configClick) {
      this.configActive = false;
    }

    this.searchClick = false;
    this.configClick = false;
    this.userMenuClick = false;
    this.rightMenuClick = false;
    this.notificationMenuClick = false;
    this.menuClick = false;
  }

  checkIfCollapsed() {
    this.showHorizontalMenu =
      this.staticMenuDesktopInactive && this.menuMode === 'static'
        ? true
        : false;

    localStorage.setItem(
      'showHorizontalMenu',
      JSON.stringify(this.showHorizontalMenu)
    );
    return this.showHorizontalMenu;
  }

  onMenuButtonClick(event) {
    this.menuClick = true;
    this.topbarUserMenuActive = false;
    this.topBarNotificationMenuActive = false;
    this.rightMenuActive = false;

    if (this.isOverlay()) {
      this.overlayMenuActive = !this.overlayMenuActive;
    }

    if (this.isDesktop()) {
      this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
    } else {
      this.staticMenuMobileActive = !this.staticMenuMobileActive;
      if (this.staticMenuMobileActive) {
        this.blockBodyScroll();
      } else {
        this.unblockBodyScroll();
      }
    }

    this.checkIfCollapsed();
    event.preventDefault();
  }

  onSearchClick(event) {
    this.search = !this.search;
    this.searchClick = !this.searchClick;
  }

  onMenuClick() {
    this.menuClick = true;
    this.resetMenu = false;
  }

  onTopbarUserMenuButtonClick(event) {
    this.userMenuClick = true;
    this.topbarUserMenuActive = !this.topbarUserMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onTopbarNotificationMenuButtonClick(event) {
    this.notificationMenuClick = true;
    this.topBarNotificationMenuActive = !this.topBarNotificationMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onRightMenuClick(event) {
    this.rightMenuClick = true;
    this.rightMenuActive = !this.rightMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onRippleChange(event) {
    this.ripple = event.checked;
  }

  onConfigClick(event) {
    this.configClick = true;
  }

  isSlim() {
    return this.menuMode === 'slim';
  }

  isOverlay() {
    return this.menuMode === 'overlay';
  }

  isDesktop() {
    return window.innerWidth > 991;
  }

  logout() {
    this.authService.logOut();
    window.location.href = `${environment.authentication.issuer}/Identity/Account/Logout?returnUrl=${window.location.origin}`;
  }

  async linkEmailToAccount() {}

  async updatePassword() {}

  isMobile() {
    return window.innerWidth <= 991;
  }

  hideOverlayMenu() {
    this.overlayMenuActive = false;
    this.staticMenuMobileActive = false;
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    } else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(
        new RegExp(
          '(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)',
          'gi'
        ),
        ' '
      );
    }
  }

  isMenuHoverActive() {
    return this.menuHoverActive;
  }

  onSetMenuHoverActive() {
    this.menuHoverActive = !this.menuHoverActive;
  }

  onSetMenuHoverActiveFalse() {
    this.menuHoverActive = false;
  }

  onSetStaticMenuMobileActiveFalse() {
    this.staticMenuMobileActive = false;
  }

  contextChanged(data) {
    if (data.entityId && data.locationId)
      this.profileService.switchContext(data.entityId, data.locationId);
    this.store.dispatch(new CLEAR_STATE());
    this.store.dispatch(setSelectedSupplier({ id: data.entityId }));
    this.store.dispatch(getEntityDetails({ id: data.entityId }));
    this.switchDirectoryMenuActive = false;
    this.router.navigate(['/']);
  }

  ngOnDestroy(): void {
    this._destroying$.next(null);
    this._destroying$.complete();
  }

  setUpMenus() {
    if (localStorage.getItem('showHorizontalMenu') === 'true') {
      this.staticMenuDesktopInactive = true;
      this.showHorizontalMenu = true;
    } else {
      this.staticMenuDesktopInactive = false;
      this.showHorizontalMenu = false;
    }

    this.menuItems = [
      {
        label: 'Home',
        icon: 'material-icons-round mi-home',
        routerLink: ['/'],
        items: [
          {
            label: 'Home',
            icon: 'material-icons-round mi-home',
            routerLink: ['/'],
          },
        ],
      },
      {
        label: 'Reports',
        permission: 'module-reports',
        icon: 'material-icons-round mi-trending-up',
        routerLink: ['/', 'reports'],
        items: [
          {
            label: 'Reports',
            permission: 'module-reports',
            icon: 'material-icons-round mi-trending-up',
            routerLink: ['/', 'reports'],
          },
        ],
      },
      {
        label: 'Transactions',
        icon: 'material-icons-outlined mi-attach-money',
        items: [
          {
            label: 'Orders',
            permission: 'module-orders',
            icon: 'material-icons-round mi-local-shipping',
            routerLink: ['/', 'orders'],
          },
          {
            label: 'Sales',
            permission: 'module-sales',
            icon: 'material-icons-round mi-receipt-long',
            routerLink: ['/', 'sales'],
          },
          {
            label: 'Transfers',
            permission: 'module-transfers',
            icon: 'material-icons-round mi-swap-vert',
            routerLink: ['/', 'transfers'],
          },
        ],
      },
      {
        label: 'Stocks',
        icon: 'material-icons-outlined mi-attach-money',
        items: [
          // {
          //   label: 'Stock Count',
          //   permission: 'module-stock-events',
          //   icon: 'material-icons-round mi-warehouse',
          //   routerLink: ['/', 'stock'],
          // },
          // {
          //   label: 'Stock Check',
          //   permission: 'module-stock-events',
          //   icon: 'material-icons-round mi-warehouse',
          //   routerLink: ['/', 'stock'],
          // },
          {
            label: 'Stock',
            permission: 'module-stock-events',
            icon: 'material-icons-round mi-warehouse',
            routerLink: ['/', 'stock'],
          },
        ],
      },
      {
        label: 'Products',
        icon: 'material-icons-outlined mi-attach-money',
        items: [
          {
            label: 'Products',
            permission: 'module-products',
            icon: 'material-icons-round mi-dashboard-customize',
            routerLink: ['/', 'catalogue'],
          },
          {
            label: 'Pricing',
            permission: 'module-pricing',
            icon: 'material-icons-outlined mi-price-change',
            routerLink: ['/', 'pricing'],
          },
        ],
      },
      {
        label: 'Bank',
        icon: 'material-icons-outlined mi-account-balance',
        items: [
          {
            label: 'Bank',
            permission: 'module-bank',
            icon: 'material-icons-outlined mi-account-balance',
            routerLink: ['/', 'bank'],
          },
        ],
      },

      {
        label: 'Contacts*',
        icon: 'material-icons-round mi-groups',
        routerLink: ['/', 'customers'],
        items: [
          {
            label: 'Customers',
            icon: 'material-icons-round mi-contacts',
            routerLink: ['/', 'customers'],
            permission: 'module-customers',
          },
          // {
          //   label: 'Suppliers',
          //   icon: 'pi pi-fw pi-user-minus',
          //   permission: 'view-customers',
          // },
          // {
          //   label: 'Competitors',
          //   icon: 'pi pi-fw pi-user-minus',
          //   permission: 'view-customers',
          // },
        ],
      },
      {
        label: 'Logistics',
        icon: 'material-icons-outlined mi-local-shipping',
        items: [
          {
            label: 'Locations',
            permission: 'module-locations',
            icon: 'material-icons-round mi-place',
            routerLink: ['/', 'locations'],
          },
          // move into a tab view
          {
            label: 'Vehicles',
            permission: 'module-vehicles',
            icon: 'material-icons-round mi-commute',
            routerLink: ['/', 'vehicles'],
          },
        ],
      },

      {
        label: 'Marketplace',
        icon: 'material-icons-outlined mi-storefront',
        items: [
          {
            label: 'Listings',
            permission: 'module-listings',
            icon: 'material-icons-round mi-newspaper',
            routerLink: ['/', 'listings'],
            disabled: true,
          },
          {
            label: 'Advertisement',
            permission: 'module-advertisements',
            icon: 'material-icons-round mi-campaign',
            routerLink: ['/', 'feed-item'],
          },
        ],
      },
      {
        label: 'Messaging',
        permission: 'module-messaging',
        icon: 'material-icons-round mi-forum',
        routerLink: ['/', 'messaging'],
        items: [
          {
            label: 'Messaging',
            permission: 'module-messaging',
            icon: 'material-icons-round mi-forum',
            routerLink: ['/', 'messaging'],
          },
        ],
      },
      {
        label: 'Maps',
        permission: 'module-maps',
        icon: 'material-icons-round mi-map',
        routerLink: ['/', 'maps'],
        items: [
          {
            label: 'Map',
            permission: 'module-maps',
            icon: 'material-icons-round mi-map',
            routerLink: ['/', 'maps'],
          },
        ],
      },

      {
        label: 'Admin',
        permission: 'module-admin',
        icon: 'material-icons-outlined mi-manage-accounts',
        items: [
          {
            label: 'Users',
            permission: 'view-users',
            icon: 'material-icons-round mi-group',
            routerLink: ['/', 'users'],
          },
          {
            label: 'Admin',
            permission: 'module-admin',
            icon: 'material-icons-round mi-manage-accounts',
            routerLink: ['/', 'admin'],
          },

          // {
          //   label: 'Users',
          //   permission: 'view-users',
          //   icon: 'material-icons-round mi-manage-accounts',
          //   routerLink: ['/', 'users'],
          // },
          //   {
          //     label: 'Company Profile',
          //     icon: 'material-icons-round mi-business',
          //     routerLink: ['/', 'company-information'],
          //   },
        ],
      },
      { separator: true },
      {
        label: 'Settings',
        icon: 'material-icons-round mi-account-balance',
        items: [
          {
            label: 'Settings',
            icon: 'material-icons-round mi-settings',
            routerLink: ['/', 'settings'],
          },
          {
            label: 'Help',
            icon: 'material-icons-round mi-help',
            routerLink: ['/', 'help'],
          },
        ],
      },
      // { separator: true },
      // {
      //   label: 'Finance',
      //   icon: 'material-icons-round mi-account-balance',
      //   permission: 'view-beta-features',
      //   items: [
      //     {
      //       label: '*Accounting',
      //       permission: 'module-accounting',
      //       icon: 'material-icons-round mi-account-balance',
      //       routerLink: ['/', 'accounting'],
      //     },
      //   ],
      // },
      // {
      //   label: 'Under Development',
      //   icon: 'material-icons-round mi-account-balance',
      //   permission: 'view-beta-features',
      //   items: [
      //     // Holistic view of everything
      //     {
      //       label: '*Calendar',
      //       permission: 'view-beta-features',
      //       icon: 'material-icons-round mi-event-note',
      //       routerLink: ['/', 'calendar'],
      //     },
      //   ],
      // },
    ];

    this.horizontalMenuItems = [
      {
        label: 'Home',
        icon: 'material-icons-round mi-home',
        routerLink: ['/'],
      },
      {
        label: 'Transactions',
        icon: 'material-icons-outlined mi-attach-money',
        items: [
          {
            label: 'Create Order',
            permission: 'module-orders',
            icon: 'material-icons-round mi-local-shipping',
            routerLink: ['/orders', 'new'],
          },
          {
            label: 'Make Sale',
            permission: 'module-orders',
            icon: 'material-icons-round mi-local-shipping',
            routerLink: ['/sales', 'create'],
          },
          {
            label: 'Orders',
            permission: 'module-orders',
            icon: 'material-icons-round mi-local-shipping',
            routerLink: ['/orders'],
          },
          {
            label: 'Sales',
            permission: 'module-sales',
            icon: 'material-icons-round mi-receipt-long',
            routerLink: ['/sales'],
          },
        ],
      },
      {
        label: 'Reports',
        permission: 'module-reports',
        icon: 'material-icons-round mi-trending-up',
        routerLink: ['/reports'],
        items: [
          {
            label: 'Sales Summary',
            routerLink: ['/reports/sales/daily-summary'],
            permission: 'view-daily-sales-report',
          },
          {
            label: 'Cash Up Report',
            routerLink: ['/reports/sales/cash-up'],
            permission: 'view-cash-up-report',
          },
          {
            label: 'Sales Record',
            routerLink: ['/reports/sales/sales-record'],
            permission: 'view-sales-record-report',
          },
          {
            label: 'Purchase Record',
            routerLink: ['/reports/sales/purchase-record'],
            permission: 'view-purchase-record-report',
          },
          {
            label: 'Inventory Events',
            routerLink: ['/reports/inventory/inventory-events'],
            permission: 'view-inventory-report',
          },
          {
            label: 'Stock Report',
            routerLink: ['/reports/inventory/stock-summary'],
            permission: 'view-stock-report',
          },
          {
            label: 'Stock Movements',
            routerLink: ['/reports/inventory/stock-movements'],
            permission: 'view-stock-movement-report',
          },
          {
            label: 'Deposit Report',
            routerLink: ['/reports/finance/deposits'],
            permission: 'view-deposit-report',
          },
        ],
      },
      {
        label: 'Stocks',
        permission: 'module-stock-events',
        icon: 'material-icons-round mi-warehouse',
        routerLink: ['/stock'],
        items: [
          {
            label: 'In',
            icon: 'material-icons-round mi-warehouse',
            routerLink: ['/stock/action/stock-in'],
          },
          {
            label: 'Out',
            icon: 'material-icons-round mi-warehouse',
            routerLink: ['/stock/action/stock-out'],
          },
          {
            label: 'Transfer',
            icon: 'material-icons-round mi-warehouse',
            routerLink: ['/stock/action/stock-transfer'],
          },
          {
            label: 'Stock Events',
            icon: 'material-icons-round mi-warehouse',
            routerLink: ['/stock/'],
          },
          {
            label: 'Stocktakes',
            icon: 'material-icons-round mi-warehouse',
            routerLink: ['/stock/stock-takes/list'],
          },
          {
            label: 'Alerts',
            icon: 'material-icons-round mi-warehouse',
            routerLink: ['/stock/stock-alerts/list'],
          },
          {
            label: 'Low Stocks',
            icon: 'material-icons-round mi-warehouse',
            routerLink: ['/stock/low-stocks/list'],
          },
        ],
      },
      {
        label: 'Products',
        icon: 'material-icons-round mi-warehouse ',
        permission: 'module-products',
        routerLink: ['/catalogue'],
        items: [
          {
            label: 'Stock',
            permission: 'module-stock-events',
            icon: 'material-icons-round mi-warehouse',
            routerLink: ['/stock'],
          },
          {
            label: 'Products',
            permission: 'module-products',
            icon: 'material-icons-round mi-dashboard-customize',
            routerLink: ['/catalogue'],
          },
          {
            label: 'Pricing',
            permission: 'module-pricing',
            icon: 'material-icons-round mi-price-change',
            routerLink: ['/pricing'],
          },
        ],
      },
      {
        label: 'Bank',
        icon: 'material-icons-outlined mi-account-balance',
        routerLink: ['/bank'],
        items: [],
      },
      // Would be really cool to add the last 5 customers the user used lets save them to local storage
      // Then push them in here

      //TODO New customer
      {
        label: 'Customers',
        icon: 'material-icons-round mi-contacts',
        routerLink: ['/customers'],
        permission: 'module-customers',
      },
      {
        label: 'Logistics',
        icon: 'material-icons-round mi-local-shipping',
        items: [
          {
            label: 'Locations',
            permission: 'module-locations',
            icon: 'material-icons-round mi-place',
            routerLink: ['/locations'],
          },
          {
            label: 'Add Location',
            permission: 'module-locations',
            icon: 'material-icons-round mi-place',
            routerLink: ['/locations', 'add'],
          },
          {
            label: 'Vehicles',
            permission: 'module-vehicles',
            icon: 'material-icons-round mi-commute',
            routerLink: ['/vehicles'],
          },
          {
            label: 'Add Vehicle',
            permission: 'module-vehicles',
            icon: 'material-icons-round mi-commute',
            routerLink: ['/vehicles', 'add'],
          },
        ],
      },
      {
        label: 'Marketplace',
        icon: 'material-icons-round mi-storefront',
        items: [
          //todo add listing shortcut
          {
            label: 'Listings',
            permission: 'module-listings',
            icon: 'material-icons-round mi-newspaper',
            routerLink: ['/listings'],
          },
          {
            label: 'Advertisement',
            permission: 'module-advertisements',
            icon: 'material-icons-round mi-campaign',
            routerLink: ['/feed-item'],
          },
        ],
      },
      {
        label: 'Messaging',
        permission: 'view-beta-features',
        icon: 'material-icons-round mi-forum',
        routerLink: ['/messaging'],
        items: [],
      },
      {
        label: 'Maps',
        permission: 'module-maps',
        icon: 'material-icons-round mi-map',
        routerLink: ['/maps'],
        items: [],
      },
      // TODO add user shorcut
      {
        label: 'Users',
        permission: 'view-users',
        icon: 'material-icons-round mi-manage-accounts',
        routerLink: ['/users'],
      },
      {
        label: 'Admin',
        routerLink: ['/admin'],
        permission: 'module-admin',
        icon: 'material-icons-round mi-manage-accounts',
        items: [
          {
            label: 'Company Profile',
            icon: 'material-icons-round mi-business',
            routerLink: ['/company-information'],
          },
          {
            label: 'Accounting',
            icon: 'material-icons-round mi-business',
            routerLink: ['/admin', 'accounting'],
          },
          {
            label: 'Roles',
            icon: 'material-icons-round mi-business',
            routerLink: ['/roles', this.activeEntityId],
          },
        ],
      },
      {
        label: 'Settings',
        icon: 'material-icons-round mi-settings',
        routerLink: ['/settings'],
      },
    ];
  }

  clearLocalStorage() {
    localStorage.clear();
    window.location.reload();
  }

  private async setUsername() {
    const hasValidAccessToken = this.authService.hasValidAccessToken();
    if (hasValidAccessToken) {
      this.authStatus = 'Loading Profile...';
      await this.loadProfile();
      const token = jwt_decode(this.authService.getAccessToken()) as any;
      this.username = `${token.given_name} ${token.family_name}`;
    } else {
      this.authStatus = 'Your session has expired, please login again.';
      this.username = null;
    }
    this.checkedUsername = true;
  }
}
